// set function parseTime,formatTime to filter
export { parseTime, formatTime } from '@/utils'

function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/* 数字 格式化*/
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

export function toThousandslsFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

export function fontdate(date) {
  if(date){
    let data =new Date(date);
    let getFullYear=data.getFullYear()+"年";
    let getMonth=data.getMonth()+1>9?(data.getMonth()+1):("0"+(data.getMonth()+1))+"月";
    let getDate=(data.getDate()>9?data.getDate():("0"+data.getDate()))+"日";
    let getHours=(data.getHours()>9?data.getHours():("0"+data.getHours()))+"时";
    let getMinutes=(data.getMinutes()>9?data.getMinutes():("0"+data.getMinutes()))+"分";
    let getSeconds=(data.getSeconds()>9?data.getSeconds():("0"+data.getSeconds()))+"秒";
    return (getFullYear+getMonth+getDate+getHours+getMinutes+getSeconds);
  }else{
    return '';
  }

}

/**
 * 保留两位小数
 */
 export const KeepTwoDecimal = (value) => {
  if (value !== null && value !== undefined && value !== 'null' && value !== 'undefined') {
    if (typeof value === 'number') {
      const str = value.toFixed(3).slice(0, -1) // 保留两位小数，不进行四舍五入
      return str
    } else {
      const str = (parseFloat(value).toFixed(3)).slice(0, -1) // 保留两位小数，不进行四舍五入
      return str
    }
  }
}

export const filterGeneral = (value) => {
  if (value !== null && value !== undefined && value !== 'null' && value !== 'undefined') {
    if (typeof value === 'string') {
      const str = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, "")
      return str
    } 
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js